import React, { useEffect } from 'react';
import baseUrl from 'shared/util/baseUrl';
import { Button } from 'components';
import { injectIntl, FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import classNames from 'classnames';
import './RiskPopup.scss';

const RiskPopup = ({
  intl, profile, optionList, onOptionClick, isRedoQuiz, summary, rtl, onShow, currentLocale,
}) => {
  const risks = {
    cautious: 'risk.cautious_description',
    moderately_cautious: 'risk.moderately_cautious_description',
    moderate: 'risk.moderate_description',
    moderately_adventurous: 'risk.moderately_adventurous_description',
    adventurous: 'risk.adventurous_description',
  };

  const classes = classNames({
    'nw-risk-popup': true,
    'nw-risk-popup--rtl': rtl,
  });

  // eslint-disable-next-line prefer-const
  let [leftButton, rightButton] = optionList ? optionList.map(item => item.payload) : [null, null];
  let leftButtonLabel;

  if (isRedoQuiz) {
    leftButton = 'risk.redoQuiz';
    leftButtonLabel = intl.formatMessage({ id: leftButton });
  } else {
    // eslint-disable-next-line prefer-destructuring
    leftButtonLabel = intl.formatMessage({ id: leftButton }).split(' ')[0];
  }

  useEffect(() => {
    if (typeof onShow === 'function') onShow();
  }, [onShow]);

  return profile ? (
    <div className={classes}>
      <div className={`nw-risk-popup__top ${isRedoQuiz ? 'nw-risk-popup__top--withBorder' : ''}`}>
        <img src={`${baseUrl}/images/risk-${currentLocale === 'AR' ? `${profile}_ar` : `${profile}`}.png`} alt={profile} />
        {
          isRedoQuiz
            ? (
              <div>
                <FormattedMessage
                  id="summary.bannerText"
                  values={{
                    profile: summary['summary.risk'] && <b style={{ color: '#3FADEC' }}>{intl.formatMessage({ id: profile })}</b>,
                    score: <b>{summary['summary.riskScore']}</b>,
                    attitude: <b>{summary['summary.riskAttitude']}</b>,
                  }}
                />
              </div>
            )
            : (
              <div>
                <h5>{intl.formatMessage({ id: profile })}</h5>
                { risks[profile] && <p>{intl.formatMessage({ id: risks[profile] })}</p>}
              </div>
            )
        }
      </div>
      {isRedoQuiz && risks[profile] && <p>{intl.formatMessage({ id: risks[profile] })}</p>}
      <div className="nw-risk-popup__bottom">
        {leftButton && <Button value={leftButtonLabel} onButtonClick={() => onOptionClick(leftButton)} isOutlineButton />}
        {rightButton && <Button value={intl.formatMessage({ id: rightButton })} onButtonClick={() => onOptionClick(rightButton)} isPrimary />}
      </div>
    </div>
  ) : null;
};

const mapStateToProps = state => ({
  currentLocale: state.rootReducer.language.locale,
  summary: state.rootReducer.summary,
});

export default connect(mapStateToProps)(injectIntl(RiskPopup));
